import './config'

import React from 'react'
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from './registerServiceWorker'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store'
import App from './pages/App'

import './index.css'

unregister()

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
// registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js